
<template> 
    <div class="row g-6 g-xl-9" >  
        <div class="col-12 col-md-12 col-xl-12"> 
            <Index  :disciplina="disciplina" :modal_cadastro="modal_cadastro" :perfis="perfis"/>  
        </div>
    </div>
</template>

<script lang="ts">
    import Index from   "./_Index.vue"  
    import { Options, Vue } from "vue-class-component";   
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 
    import {  Prop , Watch  } from 'vue-property-decorator';   

    @Options({
        name: "DisciplinaNotaPendente",
        components: { Index },  
    }) 
    export default class DisciplinaNotaPendente extends Vue { 

        @Prop( ) readonly disciplina!: any

        @authStore.Getter
		public perfis!: any  
  
        public modal_cadastro ;
        
        created(){ 
            this.modal_cadastro = 'kt_cadatrar_disciplina_avaliacao';
		}  
    }
</script>
 